import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 导入路由配置


// 创建Vue应用实例并使用路由
const app = createApp(App)
app.use(router) // 使用路由
app.mount('#app')
//createApp(App).mount('#app')
